import { render, staticRenderFns } from "./FeatureIcon.vue?vue&type=template&id=4a894b28&"
import script from "./FeatureIcon.vue?vue&type=script&lang=js&"
export * from "./FeatureIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports